export default __webpack_public_path__ + "static/media/giphy.a323e362.gif";